module.exports = __webpack_public_path__ + "img/mascot.be0b121b.png";